export const SET_LOADING = 'SET_LOADING';
export const SET_TAB = 'SET_TAB';